export const buildVariant = process.env.REACT_APP_BUILD_VARIANT;
export const isDevEnvironment = buildVariant === 'development';
export const isStagingEnvironment = buildVariant === 'staging';
export const isProdEnvironment = buildVariant === 'production';
// set DEBUG to true to enable logging at app level
export const DEBUG = false;
const config = {
  appVersion: process.env.REACT_APP_VERSION,
  appPackage: process.env.REACT_APP_NAME,
  googleAuthResponseType: 'code',
  orkApiUrl: process.env.REACT_APP_API_URL,
  identityPoolId: process.env.REACT_APP_IDENTITY_POOL_ID,
  region: process.env.REACT_APP_REGION,
  userPoolId: process.env.REACT_APP_USER_POOL_ID,
  userPoolWebClientId: process.env.REACT_APP_USER_POOL_WEB_CLIENT_ID,
  pinPointAppId: isDevEnvironment
    ? '86b64689606a48f3b8fbd483a99b005d'
    : '86b64689606a48f3b8fbd483a99b005d',
  mixpanelAnalytics: process.env.REACT_APP_MIXPANEL_TOKEN,
  googleAnalytics: process.env.REACT_APP_GOOGLE_ANALYTICS,
  s3Bucket: process.env.REACT_APP_S3_BUCKET,
  cognitoDomain: process.env.REACT_APP_COGNITO_DOMAIN,
  redirectUrl: process.env.REACT_APP_REDIRECT_URL,
  signoutRedirectUrl: process.env.REACT_APP_SIGNOUT_REDIRECT_URL,
  googleClientId: process.env.REACT_APP_GOOGLE_CLIENT_ID,
  firebaseAppId: process.env.REACT_APP_FIREBASE_APP_ID,
  firebaseApiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  firebaseAuthDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  firebaseDatabaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
  firebaseProjectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  firebaseStorageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  firebaseMessagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  firebaseMeasurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
  dataDogClientToken: process.env.REACT_APP_DATA_DOG_CLIENT_TOKEN,
  sentryDns: process.env.REACT_APP_SENTRY_DSN,
  slackClientId: process.env.REACT_APP_SLACK_CLIENT_ID,
  rtEventStreamUrl: process.env.REACT_APP_RT_EVENT_STREAM,
  firebaseAppDefaultRemoteConfig:
    process.env.REACT_APP_FIREBASE_DEFAULT_REMOTE_CONFIG,
  userConfigDynamoInvokeUrl: process.env.REACT_APP_DYNAMODB_USER_CONFIG_URL,
  s3FileUrl: name => `${process.env.REACT_APP_S3_FILE_URL}${name}`,
  feedbackModuleLink: process.env.REACT_APP_FEEDBACK_MODULE_LINK,
  reviewModuleLink: process.env.REACT_APP_REVIEW_MODULE_LINK,
  surveyModuleLink: process.env.REACT_APP_SURVEYS_MODULE_LINK,
  loginUrl: process.env.REACT_APP_LOGIN_URL,
  cookieDomain: process.env.REACT_APP_COOKIE_DOMAIN,
  feedbackApiUrl: process.env.REACT_APP_FEEDBACK_API_URL,
  blitzApiUrl: process.env.REACT_APP_BLITZ_API_URL,
  taskApiUrl: process.env.REACT_APP_TASK_API_URL,
  peopleApiUrl: process.env.REACT_APP_PEOPLE_API_URL,
  cloudApiUrl: process.env.REACT_APP_CLOUD_API_ENDPOINT,
  featurePanelCdnUrl: process.env.REACT_APP_FEATURE_PANEL_CDN_URL,
  recognitionModuleUrl: process.env.REACT_APP_RECOGNITION_MODULE_URL,
  openaiApiRootUrl: process.env.REACT_APP_OPENAI_API_LINK,
  reviewApiUrl: process.env.REACT_APP_REVIEW_API_URL
};

export default config;
